import React from 'react';

export const UserRoundIcon = ({ width = '25px', height = '26px', fill = 'currentColor', ...props }) => (
  <svg width={width} height={height} {...props} viewBox="0 0 90 90" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path fill="#fff" d="M0 0h90v90H0z" />
      <path d="M45 53.045c8.943 0 16.193-8.067 16.193-18.018s-7.25-18.018-16.194-18.018c-8.943 0-16.193 8.067-16.193 18.018s7.25 18.018 16.193 18.018z" />
      <path d="M45 0a45 45 0 000 90 44.497 44.497 0 0028.21-9.943A44.999 44.999 0 0045 0zm32.34 66.796c-2.147-6.675-8.77-12.235-17.658-15.194a19.951 19.951 0 01-29.367 0c-8.89 2.96-15.51 8.52-17.655 15.196a39 39 0 1164.68-.002z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0h90v90H0z" />
      </clipPath>
    </defs>
  </svg>
);
